import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=9751d53e"
import script from "./PackageSelector.vue?vue&type=script&lang=ts"
export * from "./PackageSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports